import React from 'react';
import { Truck, RotateCcw, BadgeIndianRupee, ShieldCheck } from 'lucide-react';
import { TRUST_BADGES } from '../mock/mockData';

const ICONS = { Truck, RotateCcw, BadgeIndianRupee, ShieldCheck };

const TrustBadges = () => {
  return (
    <section className="bg-[#FAF7F2] border-y border-[#1F2A44]/10">
      <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        {TRUST_BADGES.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <div key={i} className="flex items-center gap-3 group">
              <div className="w-12 h-12 rounded-full bg-[#E8B530]/15 border border-[#E8B530]/30 flex items-center justify-center text-[#1F2A44] group-hover:bg-[#E8B530] group-hover:scale-110 transition-all duration-300">
                <Icon size={20} />
              </div>
              <div>
                <p className="text-[#1F2A44] font-semibold text-sm">{b.title}</p>
                <p className="text-[#1F2A44]/60 text-xs">{b.sub}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBadges;
